import angular from 'angular'

import ggsUtils from '../utils'
import ggsLocale from '../ggs-locale'
import ggsTimeago from '../ggs-timeago'
import ggsImgQueue from '../ggs-img-queue'

import ggsGallery from '../gallery'
import ggsGalleryRpc from '../gallery-rpc'
import ggsGalleryOverlay from '../gallery-overlay'
import ggsGalleryProperties from '../gallery-properties'

angular
  .module('ggs', [
    ggsUtils,
    ggsLocale,
    ggsTimeago,
    ggsImgQueue,
    ggsGallery,
    ggsGalleryRpc,
    ggsGalleryOverlay,
    ggsGalleryProperties
  ])
